import type { FaireProductEntity } from "../../entity_types/product";

export const p_muuvzhcqeb: FaireProductEntity = {
  token: "p_muuvzhcqeb",
  type: "product",
  name: "Heart-shaped blue eyes pendant devil's eye pendant",
  brandToken: "b_xttg6nwn4k",
  brandName: "SoapElenGlen",
  imageUrl:
    "https://cdn.faire.com/fastly/0c3b1958bca2bdd8afe3180dceace81cdebbbce9f3aee1343be80cc5d5982da0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/89d5f3536f7e2c6c9b33f5bd5a9724d9798bf84df1457bc4269d5047074b2c41.jpeg",
    "https://cdn.faire.com/fastly/6a88ea14dc5e8e2ef18071922d00dd3744c48b251970477bd1fba9a5717bd544.jpeg",
  ],
  priceDollars: 5.52,
  description:
    '"Size - 4cm\n\nIgnite passion with our Heart-Shaped Blue Eyes Pendant, a captivating Devil\'s Eye design. This unique accessory seamlessly blends romantic elegance with an enigmatic touch. The mesmerizing blue eyes within the heart create a statement piece, adding a mysterious allure to your jewelry collection. Embrace the extraordinary and elevate your style with this distinctive pendant.\n\nADORABLE & TRENDY! Offer many hours of enjoyment for Store！💜\n🎄💗\nHow cute are these Items! These make GREAT gifts💝! \n🎀Gift Idea | Gifts Store\n\n❤️ Thank you so much for love & support ❤️\n\n•✈️ After your order is placed, we ship in 7 - 9 business days.✈️\n•❤️ All shipping comes with Tracking Numbers.🧡\n\n💌 However, your satisfaction is our first priority so please feel free to contact us if you have any question about your order.\n\n**Please note these items are Manual Measurement, Measurements are approximate.\n**Any props seen in photo are not available for sale."',
  tags: [],
  msrpDollars: 11.03,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:11.047Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
